import { memo, ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Header } from '@beeline/lk-ui';

interface CatalogPageProps {
  isLoading: boolean;
}

export const CatalogHeader = memo(function CatalogHeaderComponent({
  isLoading,
}: CatalogPageProps): ReactElement {
  const navigate = useNavigate();

  const { key: keyLocation } = useLocation();

  // keyLocation will always be 'default' if there is no previous url
  const hasPreviousLocation = keyLocation !== 'default';
  const handleOnClick = () => {
    hasPreviousLocation ? navigate(-1) : navigate('../');
  };

  return (
    <Header
      isLoading={isLoading}
      title='Каталог сервисов'
      onBackButtonClick={handleOnClick}
    />
  );
});
